import { SimulatorLocation } from '../../../../infrastructure/modules/location/interfaces/LocationTypes';
import { LessonAppointmentAvailability } from './AvailabilityTypes';

export type AddOnType = AddOnRequest;

export interface AppointmentPricingRequest {
  startDateTime: string; // format: "2023-06-27T13:15:00.000Z"
  endDateTime: string; // format: "2023-06-27T13:15:00.000Z"
  staffIds: number[];
  sessionTypeId?: number; // if it is a sim rental, backend will calculate sessionTypeId
  locationId: string;
  email?: string;
  partySize?: string;
}

export interface ServicePricing {
  staffId: number;
  clientServiceId: number | null;
  costSummary: CostSummary[];
  addOns?: AddOnRequest;
}

export interface CostSummary {
  title: string;
  startTime: string;
  endTime: string;
  duration: number;
  price: number;
  sessionTypeId: number;
}

export interface SessionBreakdown {
  title: string;
  startTime: Date;
  endTime: Date;
  duration: number;
  sessionTypeId: number;
  defaultTimeLength: number;
  programId: number;
  servicePrice: number;
  serviceProgramId: number;
}

export interface BookAppointmentRequest {
  email: string;
  promoCode: string;
  partySize: number | undefined;
  leftHanded?: boolean;
  clubRental?: boolean;
  appointments: AddAppointment[];
  addOns?: AddOnRequest[];
  isPrepaid?: boolean;
  payWithPoints?: boolean;
}

export interface CancelAppointmentRequest {
  appointmentId: number[];
}
export interface AddOnRequest {
  name: string;
  sessionTypeId: number;
  cost?: number;
}
export interface AddAppointment {
  startDateTime: string;
  endDateTime: string;
  staffId: number;
  clientServiceId?: number;
  notes: string;
  sessionTypeId: number;
  resourceId: number | null;
  cost?: number;
}

export interface BookedAppointmentResponse {
  id: number;
  uuids: string[];
  duration: number;
  status: string;
  startDateTime: string;
  endDateTime: string;
  notes: string;
  resourceId: number | null;
  sessionTypeId: number;
  locationId: number;
  staffId: number;
  clientId: string;
}

export interface ClientAppointmentResponse {
  internalLocId: string;
  id: number;
  duration: number;
  cancelIds?: number[];
  cancelUUIDs?: string[];
  status: string;
  startDateTime: string;
  startDateTimeUTC: string;
  endDateTime: string;
  endDateTimeUTC: string;
  locationTimezone: string;
  notes: string;
  locationName: string;
  locationId: number;
  siteId: number;
  instructor?: string | null;
  staffImage: string | null;
  appointmentType: string;
  cost?: number | null;
  paidWithPoints: boolean;
  priceInPoints: number | null;
  hasArrived: boolean;
  checkInFromDateTime: string;
  checkInFromDateTimeUTC: string;
  pointsToEarn?: number;
  appointmentName?: string;
}

export interface ClientUpcomingAppointmentResponse extends ClientAppointmentResponse {
  hasPaymentDetails: boolean;
}

export interface CanceledAppointmentResponse {
  id: number[];
  status: string;
}

export interface BookingWaiverRequest {
  locationId: string;
  waiverUrl: string;
  appointmentId: number;
  startDateTime: string;
  endDateTime: string;
  emails: string[];
  clientId: string;
}

export enum BookingWizardFlowTypes {
  Lesson = 'lesson',
  Simulator = 'simulator',
  Bowling = 'bowling',
  FirstLesson = 'firstLesson',
  ClubFitting = 'clubFitting',
}

export interface Appointment {
  title: string;
  price: number;
  duration: number;
  sessionTypeId: number;
  staffId: number;
  startDateTime: string;
  endDateTime: string;
  resourceId?: number | null;
}

export interface SimulatorResourceAvailability {
  resourceId: number;
  time: Date;
}

export interface Service {
  title: string;
  price: number;
  sessionTypeId: number;
  defaultTimeLength: number;
  availabilities: SimulatorResourceAvailability[];
}

export interface AppointmentBooking {
  id?: string;
  location?: string | undefined;
  locationDetails?: SimulatorLocation | undefined;
  experienceType?: BookingWizardFlowTypes | undefined;
  reservationDate?: string;
  partySize?: string;
  startTime?: string;
  endTime?: string;
  sessionLength?: string;
  sessionTypeId?: number;
  instructor?: string;
  email?: string;
  lessonType?: number;
  appointments?: Appointment[];
  addOns?: AddOnBooking[];
  resourceId?: number;
  instructorDetails?: Partial<LessonAppointmentAvailability>;
  confirmedBooking?: BookedAppointmentResponse[];
}

export interface AddOnBooking {
  name: string;
  sessionTypeId?: number;
  cost: number;
}
export interface HourlySimulatorPricingDto {
  partyRentalFee?: number | null;
}

export interface HourlySimulatorPricingRequestDto {
  locationId: string;
  email?: string;
}

export interface CheckInRequest {
  appointmentIds: number[];
}

export interface FoodOrderRequest {
  appointmentId: number[];
  order: FoodOrder[];
  notes?: string;
}

export interface FoodOrder {
  id: string;
  variation: string;
  name: string;
  quantity: number;
  price: number;
}
